// extracted by mini-css-extract-plugin
module.exports = {"contato":"Contact_contato__1hcQ0","iconesContato":"Contact_iconesContato__3gToj","iconeContato":"Contact_iconeContato__3ptFo"};